import React from 'react';

export const CheckedIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 10" {...props}>
    <path d="M11.08.31L3.71 7.19l-2-2a1.12 1.12 0 0 0-1.47 0 1.12 1.12 0 0 0 0 1.47L3 9.39a1.06 1.06 0 0 0 .74.37 1.74 1.74 0 0 0 .74-.25l8.1-7.61a.92.92 0 0 0 0-1.47c-.52-.49-1.14-.61-1.5-.12z" />
  </svg>
);
